export enum InputSize {
  small = 'small',
  mediumLegacy = 'mediumLegacy', // NOTE: Legacy to support 36px height, i.e. our existing inputs
  medium = 'medium',
  large = 'large',
}

export const inputSizes = Object.values(InputSize);
